import actions from '@/core/store/adesao/itens-adesao/actions'
import state from '@/core/store/adesao/itens-adesao/state'
import mutations from '@/core/store/adesao/itens-adesao/mutations'
import estorno from '@/core/store/adesao/itens-adesao/estorno'

export default {
	actions,
	state,
	mutations,
	modules: {
		estorno,
	},
}
